/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IndiceBrancheDto } from './IndiceBrancheDto';
import {
    IndiceBrancheDtoFromJSON,
    IndiceBrancheDtoFromJSONTyped,
    IndiceBrancheDtoToJSON,
    IndiceBrancheDtoToJSONTyped,
} from './IndiceBrancheDto';
import type { ValeurIndiceDto } from './ValeurIndiceDto';
import {
    ValeurIndiceDtoFromJSON,
    ValeurIndiceDtoFromJSONTyped,
    ValeurIndiceDtoToJSON,
    ValeurIndiceDtoToJSONTyped,
} from './ValeurIndiceDto';

/**
 * Indice du référentiel : un code, un libellé, les branches auxquelles il s'applique et l'historique de ses valeurs.
 * @export
 * @interface IndiceDto
 */
export interface IndiceDto {
    /**
     * 
     * @type {string}
     * @memberof IndiceDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IndiceDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IndiceDto
     */
    label?: string | null;
    /**
     * 
     * @type {Array<IndiceBrancheDto>}
     * @memberof IndiceDto
     */
    branches?: Array<IndiceBrancheDto> | null;
    /**
     * Historique complet. Chaque valeur ne porte qu'une date de début : c'est la valeur suivante qui borne la précédente, il n'existe pas de date de fin.
     * @type {Array<ValeurIndiceDto>}
     * @memberof IndiceDto
     */
    values?: Array<ValeurIndiceDto> | null;
    /**
     * 
     * @type {ValeurIndiceDto}
     * @memberof IndiceDto
     */
    currentValue?: ValeurIndiceDto;
}

/**
 * Check if a given object implements the IndiceDto interface.
 */
export function instanceOfIndiceDto(value: object): value is IndiceDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function IndiceDtoFromJSON(json: any): IndiceDto {
    return IndiceDtoFromJSONTyped(json, false);
}

export function IndiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'] == null ? undefined : json['label'],
        'branches': json['branches'] == null ? undefined : ((json['branches'] as Array<any>).map(IndiceBrancheDtoFromJSON)),
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(ValeurIndiceDtoFromJSON)),
        'currentValue': json['currentValue'] == null ? undefined : ValeurIndiceDtoFromJSON(json['currentValue']),
    };
}

export function IndiceDtoToJSON(json: any): IndiceDto {
    return IndiceDtoToJSONTyped(json, false);
}

export function IndiceDtoToJSONTyped(value?: IndiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'branches': value['branches'] == null ? undefined : ((value['branches'] as Array<any>).map(IndiceBrancheDtoToJSON)),
        'values': value['values'] == null ? undefined : ((value['values'] as Array<any>).map(ValeurIndiceDtoToJSON)),
        'currentValue': ValeurIndiceDtoToJSON(value['currentValue']),
    };
}

